// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"d0d6e089","770":"d90b5f33","787":"0ca7f82e"}[chunkId] + ".chunk.js";
};